import { gql, useMutation } from "@apollo/client";

export const TRANSCRIBE_AUDIO = gql`
  mutation TranscribeAudio($audioBase64: String!, $language: String) {
    transcribeAudio(audioBase64: $audioBase64, language: $language)
  }
`;

export interface TranscribeAudioData {
  transcribeAudio: string;
}

export interface TranscribeAudioVars {
  audioBase64: string;
  language?: string;
}

export const useTranscribeAudio = () =>
  useMutation<TranscribeAudioData, TranscribeAudioVars>(TRANSCRIBE_AUDIO);
